import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { BusinessProvider } from './context/BusinessContext';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import SuperOwlApp from './components/SuperOwlApp';
import AboutPage from './pages/AboutPage';
import FeaturesPage from './pages/FeaturesPage';
import PricingPage from './pages/PricingPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import ContactPage from './pages/ContactPage';
import AccountSettingsPage from './pages/AccountSettingsPage'; // <-- add this import

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  if (!user) {
    if (location.pathname !== '/') {
      return <Navigate to="/" />;
    }
  }
  
  return children;
};

function App() {
  const { user } = useAuth();

  return (
    <AuthProvider>
      <BusinessProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route
            path="/app/*"
            element={user ? <SuperOwlApp /> : <Navigate to="/login" />}
          />
          <Route
            path="/account-settings"
            element={user ? <AccountSettingsPage /> : <Navigate to="/login" />}
          />
        </Routes>
      </BusinessProvider>
    </AuthProvider>
  );
}

export default App;
